import React from 'react';
import { storage, path } from '@commons';
import { Route, Redirect } from 'react-router-dom';

export const PublicRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        <Component {...props} />
    )} />
);
